<!--
 * @Description: 弹窗demo 页面
 * @Author: mhf
 * @Date: 2024/1/28 13:23
-->
<template>
  <el-dialog
    width="700px"
    v-dialog-out
    append-to-body
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">dialog-body</div>

    <div class="dialog-footer">
      <el-button @click="">取 消</el-button>
      <el-button type="primary" @click="">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "demoDialog",
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      title: "",
    };
  },
  methods: {
    showDialog(data) {
      this.dialogVisible = true;
      this.title = data.title;
      this.getDetail(data.data.id);
    },

    hideDialog() {
      this.dialogVisible = false;
    },

    getDetail(id) {},
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 20px 0 0 !important;
}

.dialog-body {
  padding: 0 20px;
  max-height: 65vh;
  overflow-y: auto;
}

.dialog-footer {
  text-align: center;
  padding: 10px 0 18px;
}
</style>
